import { CosellFieldMapping } from '../../../modules/coSellMappingManager/reducer'

// Mock field mappings for Azure "Help from Microsoft" section
export const azureHelpFromMicrosoftMockData: Record<
  string,
  CosellFieldMapping
> = {
  typeOfHelp: {
    referralField: 'typeOfHelp',
    referralFieldType: 'Picklist',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Type of Help',
    required: true,
    displayOrder: 1,
    defaultValue: '',
    category: 'Help from Microsoft',
    picklist: [
      {
        value: 'NoHelpRequired',
        label: 'No help required at this time',
      },
      {
        value: 'WorkloadSpecificValueProposition',
        label: 'Workload - specific value proposition',
      },
      {
        value: 'CustomerTechnicalArchitecture',
        label: 'Customer technical architecture',
      },
      {
        value: 'ProofOfConceptOrDemo',
        label: 'Proof of concept / Demo',
      },
      {
        value: 'QuotesOrLicensing',
        label: 'Quotes / Licensing',
      },
      {
        value: 'PostSalesCustomerSuccess',
        label: 'Post - sales customer success',
      },
      {
        value: 'GeneralOrOther',
        label: 'Other',
      },
    ],
    picklistMappings: null,
  },
  wouldLikeMicrosoftSellersToViewDeal: {
    referralField: 'wouldLikeMicrosoftSellersToViewDeal',
    referralFieldType: 'Boolean',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Would Like Microsoft Sellers To View Deal',
    required: false,
    displayOrder: 2,
    defaultValue: '',
    category: 'Help from Microsoft',
    picklist: null,
    picklistMappings: null,
  },
  notesToMicrosoft: {
    referralField: 'notesToMicrosoft',
    referralFieldType: 'Text',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Notes to Microsoft',
    required: false,
    displayOrder: 3,
    defaultValue: '',
    category: 'Help from Microsoft',
    picklist: null,
    picklistMappings: null,
  },
}

// Mock field mappings for Azure "Deal Details" section
export const azureDealDetailsMockData: Record<string, CosellFieldMapping> = {
  dealName: {
    referralField: 'dealName',
    referralFieldType: 'Text',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Deal Name',
    required: true,
    displayOrder: 1,
    defaultValue: '',
    category: 'Deal details',
    picklist: null,
    picklistMappings: null,
  },
  dealType: {
    referralField: 'dealType',
    referralFieldType: 'Picklist',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Deal Type',
    required: true,
    displayOrder: 2,
    defaultValue: '',
    category: 'Deal details',
    picklist: [
      { value: 'New Business', label: 'New Business' },
      { value: 'Upsell', label: 'Upsell' },
      { value: 'Renewal', label: 'Renewal' },
    ],
    picklistMappings: null,
  },
  estimatedValue: {
    referralField: 'estimatedValue',
    referralFieldType: 'Number',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Estimated Value',
    required: false,
    displayOrder: 3,
    defaultValue: '',
    category: 'Deal details',
    picklist: null,
    picklistMappings: null,
  },
  estimatedCloseDate: {
    referralField: 'estimatedCloseDate',
    referralFieldType: 'Date',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Estimated Close Date',
    required: false,
    displayOrder: 4,
    defaultValue: '',
    category: 'Deal details',
    picklist: null,
    picklistMappings: null,
  },
  currency: {
    referralField: 'currency',
    referralFieldType: 'Picklist',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Currency',
    required: false,
    displayOrder: 5,
    defaultValue: '',
    category: 'Deal details',
    picklist: [
      { value: 'USD', label: 'USD' },
      { value: 'EUR', label: 'EUR' },
      { value: 'GBP', label: 'GBP' },
      { value: 'CAD', label: 'CAD' },
    ],
    picklistMappings: null,
  },
  location: {
    referralField: 'location',
    referralFieldType: 'Text',
    hubspotObject: '',
    hubspotField: '',
    hubspotFieldLabel: '',
    hubspotFieldType: '',
    isHidden: false,
    isReadonly: false,
    isMapped: false,
    label: 'Location',
    required: false,
    displayOrder: 6,
    defaultValue: '',
    category: 'Deal details',
    picklist: null,
    picklistMappings: null,
  },
}

// Mock field mappings for Azure "Solutions Offered" section
export const azureSolutionsOfferedMockData: Record<string, CosellFieldMapping> =
  {
    solutionsOffered: {
      referralField: 'solutionsOffered',
      referralFieldType: 'Multipicklist',
      hubspotObject: '',
      hubspotField: '',
      hubspotFieldLabel: '',
      hubspotFieldType: '',
      isHidden: false,
      isReadonly: false,
      isMapped: false,
      label: 'Solutions Offered',
      required: true,
      displayOrder: 1,
      defaultValue: [],
      category: 'Solutions offered',
      picklist: [
        { value: 'Azure', label: 'Azure' },
        { value: 'Microsoft 365', label: 'Microsoft 365' },
        { value: 'Dynamics 365', label: 'Dynamics 365' },
        { value: 'Power Platform', label: 'Power Platform' },
        { value: 'Security', label: 'Security' },
      ],
      picklistMappings: null,
    },
    solutionArea: {
      referralField: 'solutionArea',
      referralFieldType: 'Picklist',
      hubspotObject: '',
      hubspotField: '',
      hubspotFieldLabel: '',
      hubspotFieldType: '',
      isHidden: false,
      isReadonly: false,
      isMapped: false,
      label: 'Solution Area',
      required: false,
      displayOrder: 2,
      defaultValue: '',
      category: 'Solutions offered',
      picklist: [
        { value: 'Infrastructure', label: 'Infrastructure' },
        { value: 'Data & AI', label: 'Data & AI' },
        { value: 'Digital Apps', label: 'Digital Apps' },
        { value: 'Business Applications', label: 'Business Applications' },
        { value: 'Modern Work', label: 'Modern Work' },
        { value: 'Security', label: 'Security' },
      ],
      picklistMappings: null,
    },
    solutionPlay: {
      referralField: 'solutionPlay',
      referralFieldType: 'Text',
      hubspotObject: '',
      hubspotField: '',
      hubspotFieldLabel: '',
      hubspotFieldType: '',
      isHidden: false,
      isReadonly: false,
      isMapped: false,
      label: 'Solution Play',
      required: false,
      displayOrder: 3,
      defaultValue: '',
      category: 'Solutions offered',
      picklist: null,
      picklistMappings: null,
    },
  }

// Combined mock data for all Azure sections
export const azureMockFieldMappings = {
  ...azureHelpFromMicrosoftMockData,
  ...azureDealDetailsMockData,
  ...azureSolutionsOfferedMockData,
}

export const azureHubspotFieldMockData = [
  {
    description:
      "Contact's street address, including apartment or unit number.",
    displayLabel: 'Street Address',
    fieldType: 'Text',
    internalName: 'address',
    objectType: 'Contacts',
  },
  {
    description:
      "Contact's street address, including apartment or unit number.",
    displayLabel: 'Street Address',
    fieldType: 'Text',
    internalName: 'city',
    objectType: 'Contacts',
  },
  {
    description:
      "Contact's street address, including apartment or unit number.",
    displayLabel: 'Street Address',
    fieldType: 'Text',
    internalName: 'state',
    objectType: 'Contacts',
  },
  {
    description:
      "Contact's street address, including apartment or unit number.",
    displayLabel: 'Street Address',
    fieldType: 'Text',
    internalName: 'country',
    objectType: 'Contacts',
    options: [
      { value: 'true', label: 'True' },
      { value: 'false', label: 'False' },
    ],
  },
]
